import React from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ChartBarIcon } from "@heroicons/react/24/outline";
import { HsePageChrome } from "../../../../../components/dashboard/hse/HsePageChrome";

/**
 * HSE/KS KPI Definition Edit - Create or edit KPI definition
 */
export const HseKsKpiDefinitionEdit = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const isNew = !id;

  return (
    <HsePageChrome
      title={isNew ? "Ny KPI" : `Rediger KPI #${id}`}
      subtitle="KPI-skjema"
    >
      <div className="mx-auto mt-8 grid max-w-3xl grid-cols-1 gap-6 sm:px-6 lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-3">
        <div className="space-y-6 lg:col-span-3 lg:col-start-1 sm:col-span-3">
          <div className="bg-white shadow sm:rounded-lg">
            <div className="px-4 py-5 sm:p-6">
              <p className="text-gray-500">KPI-skjema kommer snart...</p>
            </div>
          </div>
        </div>
      </div>
    </HsePageChrome>
  );
};

